export default __webpack_public_path__ + "static/media/backlog.ada2abc0.jpg";